import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, emitirBaixaVeiculo } from './types';

export const INITIAL_STATE: emitirBaixaVeiculo = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): emitirBaixaVeiculo {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EMITIR_BAIXA_VEICULO_REQUEST: {
				break;
			}

			case Types.EMITIR_BAIXA_VEICULO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EMITIR_BAIXA_VEICULO_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.EMITIR_BAIXA_VEICULO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
